module.exports = __webpack_public_path__ + "img/youtube-logo.ebb63496.svg";